import { render, staticRenderFns } from "./ConfiguracoesMensagemRespostaOptout.vue?vue&type=template&id=2a22347c"
import script from "./ConfiguracoesMensagemRespostaOptout.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensagemRespostaOptout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports